export default "__VITE_ASSET__B5a8jsuW__"